(function () {
  'use strict';

  if (window.BrilintonStudioUI && typeof window.BrilintonStudioUI.normalizeAll === 'function') {
    window.BrilintonStudioUI.normalizeAll(document);
    return;
  }

  var CARD_SELECTOR = '.studio-card, [data-studio-option-card]';

  var OPTION_SELECTOR = CARD_SELECTOR + ', .studio__option[data-studio-option], [data-studio-option][data-option-name]';

  var RAIL_SELECTOR = [
    '[data-studio-apple-sizes]',
    '[data-studio-royal-models]',
    '[data-studio-band-colors]',
    '[data-studio-colors]',
    '[data-studio-watchware-finishes]',
    '[data-studio-collection-ww-colors]',
    '.studio-rail__track'
  ].join(',');

  function text(node) {
    return String(node && node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function first(root, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var node = root.querySelector(selectors[i]);
      if (node) return node;
    }
    return null;
  }

  function normalizeCard(card) {
    if (!card || !card.matches || !card.closest('.studio')) return;
    if (card.classList.contains('studio__option') && !card.hasAttribute('data-studio-option-card')) return;

    card.classList.add('studio-card');
    card.setAttribute('data-studio-option-card', '');

    var optionName = card.getAttribute('data-option-name') || '';
    if (card.hasAttribute('data-device-size')) card.classList.add('studio-card--device');
    if (card.hasAttribute('data-model-index') || /royalmodel/i.test(optionName)) card.classList.add('studio-card--model');
    if (/bandware/i.test(optionName) || card.hasAttribute('data-band-index')) card.classList.add('studio-card--bandware');
    if (/watchwarefinish/i.test(optionName) || card.hasAttribute('data-entry-index')) card.classList.add('studio-card--watchware');

    var media = first(card, [':scope > .studio-card__media']);
    if (!media) {
      media = document.createElement('span');
      card.insertBefore(media, card.firstChild);
    }
    media.classList.add('studio-card__media');

    var image = first(media, ['img']);
    if (image) {
      image.classList.add('studio-card__image');
    }

    var title = first(card, [':scope > .studio-card__title']);
    if (title) {
      title.classList.add('studio-card__title');
    }

    var meta = first(card, [':scope > .studio-card__meta']);
    if (meta) {
      meta.classList.add('studio-card__meta');
    }

    var content = card.querySelector(':scope > .studio-card__content');
    if (!content && (title || meta)) {
      content = document.createElement('span');
      content.className = 'studio-card__content';
      if (title) content.appendChild(title);
      if (meta) content.appendChild(meta);
      card.appendChild(content);
    }

    if (!card.getAttribute('data-summary-secondary') && title) {
      card.setAttribute('data-summary-secondary', text(title));
    }

    var selected = card.classList.contains('is-selected') || card.getAttribute('aria-selected') === 'true';
    var pressed = selected ? 'true' : 'false';
    if (card.getAttribute('aria-pressed') !== pressed) card.setAttribute('aria-pressed', pressed);
  }

  function normalizeRail(rail) {
    if (!rail || !rail.closest('.studio')) return;
    rail.classList.add('studio-rail', 'studio-rail__track');
  }

  function normalize(root) {
    if (!root) return;
    if (root.matches && root.matches(CARD_SELECTOR)) normalizeCard(root);
    if (root.matches && root.matches(RAIL_SELECTOR)) normalizeRail(root);
    Array.prototype.forEach.call(root.querySelectorAll ? root.querySelectorAll(CARD_SELECTOR) : [], normalizeCard);
    Array.prototype.forEach.call(root.querySelectorAll ? root.querySelectorAll(RAIL_SELECTOR) : [], normalizeRail);
  }

  function groupFor(option) {
    return option && option.closest('[data-studio-group], .studio__group');
  }

  function summaryFor(group) {
    return group && group.querySelector('[data-summary-value], [data-studio-model-summary], .studio__summary-value');
  }

  function titleFor(option) {
    return text(first(option, ['.studio-card__title']));
  }

  function summaryValue(option) {
    if (!option) return '';
    var primary = option.getAttribute('data-summary-primary') || '';
    var secondary = option.getAttribute('data-summary-secondary') || '';
    var name = (option.getAttribute('data-option-name') || '').toLowerCase();
    var label = titleFor(option) || option.getAttribute('data-option-value') || option.getAttribute('aria-label') || '';

    if (name === 'bandware' || option.hasAttribute('data-band-index')) {
      if (!secondary) secondary = label;
      if (!primary) {
        var material = option.getAttribute('data-material') || '';
        var productTitle = option.getAttribute('data-product-title') || '';
        var edition = (productTitle.match(/^([^\s-]+)/) || [])[1] || '';
        primary = [edition, material].filter(Boolean).join(' ').trim();
      }
      return [primary, secondary].filter(Boolean).join(' / ');
    }

    if (!primary) primary = option.getAttribute('data-summary-line-label') || option.getAttribute('data-summary-label') || option.getAttribute('data-option-label') || label || option.getAttribute('data-option-value');
    return [primary, secondary && secondary !== primary ? secondary : ''].filter(Boolean).join(' / ');
  }

  function splitSummary(value) {
    return String(value || '').split(/\s*\/\s*/).map(function (part) { return part.trim(); }).filter(Boolean);
  }

  function readableOptionValue(option) {
    var label = titleFor(option) || text(option);
    if (label) return label;
    var value = option.getAttribute('data-option-value') || '';
    if (value === 'apple-watch') return 'Apple Watch';
    if (value === 'royal-pop') return 'Royal Pop';
    if (value === 'watchware') return 'WatchWare';
    if (value === 'direct') return 'Direct';
    return value.replace(/[-_]+/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function previewValue(option, committed) {
    var family = option.getAttribute('data-option-name') || option.getAttribute('data-studio-option') || '';
    var normalized = family.toLowerCase();
    var full = summaryValue(option);
    var parts = splitSummary(committed);
    var replacement = readableOptionValue(option);

    if (normalized === 'device') {
      if (!parts.length) parts = ['', ''];
      parts[0] = replacement;
      return parts.filter(Boolean).join(' / ');
    }
    if (normalized === 'mode') {
      if (!parts.length) parts = ['', ''];
      while (parts.length < 2) parts.push('');
      parts[1] = replacement;
      return parts.filter(Boolean).join(' / ');
    }
    if (normalized === 'frametype' || normalized.indexOf('watchwareline-') === 0 || normalized === 'bandmaterial' || normalized === 'material') {
      if (parts.length > 1) {
        parts[0] = replacement;
        return parts.filter(Boolean).join(' / ');
      }
    }
    if (normalized === 'framefinish') {
      if (parts.length > 1) {
        parts[1] = replacement;
        return parts.filter(Boolean).join(' / ');
      }
    }
    return full || replacement;
  }

  function previewSummary(option) {
    var group = groupFor(option);
    var summary = summaryFor(group);
    if (!summary) return;
    if (!summary.hasAttribute('data-studio-committed-summary')) summary.setAttribute('data-studio-committed-summary', text(summary));
    summary.setAttribute('data-studio-preview-family', option.getAttribute('data-option-name') || '');
    var committed = summary.getAttribute('data-studio-committed-summary') || text(summary);
    var value = previewValue(option, committed);
    if (value) summary.textContent = value;
  }

  function restoreSummary(option) {
    var summary = summaryFor(groupFor(option));
    if (!summary) return;
    var value = summary.getAttribute('data-studio-committed-summary') || '';
    if (value) summary.textContent = value;
    summary.removeAttribute('data-studio-preview-family');
  }

  function commitSummary(option) {
    requestAnimationFrame(function () {
      var summary = summaryFor(groupFor(option));
      if (!summary) return;
      summary.setAttribute('data-studio-committed-summary', text(summary));
    });
  }

  function measurePdpHeight(sectionId) {
    if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) return null;
    var section = document.querySelector('#MainProduct-' + sectionId) || document;
    var selectors = [
      '#MediaGallery-' + sectionId + ' .product__media-item.is-active .product__media',
      '#MediaGallery-' + sectionId + ' .product__media-item.is-active img',
      '#MediaGallery-' + sectionId + ' .product__media-item.is-active',
      '#MediaGallery-' + sectionId + ' .studio-gallery-viewer',
      '#MediaGallery-' + sectionId + ' .product__media-list',
      '#MainProduct-' + sectionId + ' .product__media-wrapper'
    ];
    var values = [];
    selectors.forEach(function (selector) {
      var element = section.querySelector(selector) || document.querySelector(selector);
      if (!element) return;
      var rect = element.getBoundingClientRect();
      var value = Math.round(rect && rect.height ? rect.height : 0);
      if (value >= 420 && value <= 1600) values.push(value);
    });
    var height = values.length ? Math.min.apply(Math, values) : 752;
    var viewport = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var viewportCap = Math.max(520, Math.floor(viewport - 170));
    height = Math.min(height, viewportCap, 1320);
    return Math.max(520, height - 41);
  }

  function syncPdpHeight(root, info, sectionId) {
    var height = measurePdpHeight(sectionId);
    if (!height) return;
    root.style.setProperty('--studio-panel-height', height + 'px');
    if (info) info.style.setProperty('--studio-panel-height', height + 'px');
  }

  document.addEventListener('pointerover', function (event) {
    var option = event.target.closest && event.target.closest(OPTION_SELECTOR);
    if (!option || !option.closest('.studio') || (event.relatedTarget && option.contains(event.relatedTarget))) return;
    previewSummary(option);
  });
  document.addEventListener('pointerout', function (event) {
    var option = event.target.closest && event.target.closest(OPTION_SELECTOR);
    if (!option || !option.closest('.studio') || (event.relatedTarget && option.contains(event.relatedTarget))) return;
    restoreSummary(option);
  });
  document.addEventListener('focusin', function (event) {
    var option = event.target.closest && event.target.closest(OPTION_SELECTOR);
    if (option && option.closest('.studio')) previewSummary(option);
  });
  document.addEventListener('focusout', function (event) {
    var option = event.target.closest && event.target.closest(OPTION_SELECTOR);
    if (option && option.closest('.studio')) restoreSummary(option);
  });
  document.addEventListener('click', function (event) {
    var option = event.target.closest && event.target.closest(OPTION_SELECTOR);
    if (option && option.closest('.studio')) commitSummary(option);
  }, true);

  var observedStudios = typeof WeakSet === 'function' ? new WeakSet() : null;

  function initializeStudio(studio) {
    if (!studio || !studio.matches || !studio.matches('.studio')) return;
    normalize(studio);
    if (observedStudios && observedStudios.has(studio)) return;
    if (observedStudios) observedStudios.add(studio);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes || [], function (node) {
          if (node.nodeType === 1) normalize(node);
        });
      });
    });
    observer.observe(studio, {
      childList: true,
      subtree: true
    });
  }

  function normalizeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.studio')) initializeStudio(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('.studio'), initializeStudio);
  }

  function boot() {
    normalizeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    normalizeAll(event.target || document);
  });

  window.BrilintonStudioUI = {
    normalize: normalize,
    normalizeAll: normalizeAll,
    normalizeCard: normalizeCard,
    summaryValue: summaryValue,
    syncPdpHeight: syncPdpHeight,
    measurePdpHeight: measurePdpHeight
  };
})();
